module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/~/babel-runtime/core-js/object/create.js
// module id = 1094
// module chunks = 0